import React from "react";

// Styles
import DealFilterContainer from "./DealFilter.styles";

// Components
import TextField from "../../../Common/TextField/TextField";
import ButtonSmall from "../../../Common/ButtonSmall/ButtonSmall";

// FontAwesome
import { faSearch } from "@fortawesome/free-solid-svg-icons";

// Interface
import { DealFilters } from "assets/interfaces/growth_voting";

interface Props {
    filters: DealFilters;
    setFilters: React.Dispatch<React.SetStateAction<DealFilters>>;
    setSearch: React.Dispatch<React.SetStateAction<boolean>>;
}

const DealFilter = ({ filters, setFilters, setSearch }: Props) => {
    const setTextFilter = (text: string) => {
        setFilters({ ...filters, search: text });
    };

    return (
        <DealFilterContainer>
            <div className={"filters"}>
                <TextField
                    placeholder="Search.."
                    change={setTextFilter}
                    value={filters.search}
                />
                <ButtonSmall
                    text="Search"
                    click={() => {
                        setSearch(true);
                    }}
                    icon={faSearch}
                />
            </div>
        </DealFilterContainer>
    );
};

export default DealFilter;
